// AI Generated Test
import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { MonLogService } from 'ng2/services/mon-log-service/mon-log.service';

@Directive({
    selector: '[monTabControl]',
    standalone: false,
})
export class MonTabControlDirective implements AfterViewInit {
    @Input() monTabControl: number | string = 0; // Default to 0 if not provided

    constructor (
        private elementRef: ElementRef,
        private monLogService: MonLogService,
    ) {}

    ngAfterViewInit (): void {
        const el = this.elementRef.nativeElement;
        el.setAttribute('mon-tab-control', this.monTabControl.toString());

        if (this.inputOrButton(el)) {
            this.setTabListener(el);
        } else {
            // Give time to render inner inputs
            setTimeout(() => {
                const inputElement = el.querySelector('input, button');
                if (inputElement) {
                    this.setTabListener(inputElement);
                }
            });
        }
    }

    private inputOrButton (el: any): boolean {
        return el instanceof HTMLInputElement || el instanceof HTMLButtonElement;
    }

    private tabListener = (e: any): void => {
        const el = e.target;
        let focusPool: any;
        let focusReceiver: any;
        const direction = +1;
        let index: any;
        let poolParent: any;

        if (e.key === 'Tab' && el) {
            let targetEl = el;
            if (!(this.inputOrButton(el) && el.hasAttribute('mon-tab-control'))) {
                targetEl = el.closest('[mon-tab-control]');
                if (!targetEl) {
                    this.monLogService.warn('No element at monTabControl directive!');
                }
            }

            index = Number(this.monTabControl);

            if (!isNaN(index)) {
                poolParent = targetEl.closest('[mon-tab-control-parent]');
                focusPool = Array.from(poolParent.querySelectorAll('[mon-tab-control="' + index + '"]'))
                    .filter((elem: any) => {
                        return !elem.disabled;
                    });

                let actualDirection = direction;
                if (e.shiftKey) {
                    actualDirection = -1;
                }

                focusReceiver = this.ensureFocusReceiver(focusPool[focusPool.indexOf(targetEl) + actualDirection]);

                if (focusReceiver) {
                    this.stopAndFocus(focusReceiver, e);
                } else {
                    this.focusAnotherRow(poolParent, index, actualDirection, e);
                }
            }
        }
    };

    private ensureFocusReceiver (focusReceiver: any): any {
        if (focusReceiver && !this.inputOrButton(focusReceiver)) {
            return focusReceiver.querySelector('input, button');
        }
        return focusReceiver;
    }

    private focusAnotherRow (poolParent: any, index: any, direction: any, e: any): void {
        const newRow = Array.from(poolParent.querySelectorAll('[mon-tab-control="' + (index + direction) + '"]'))
            .filter((elem: any) => {
                return !elem.disabled;
            });
        let newFocusReceiver: any;

        if (direction > 0) {
            newFocusReceiver = this.ensureFocusReceiver(newRow.shift());
        } else {
            newFocusReceiver = this.ensureFocusReceiver(newRow.pop());
        }

        if (newFocusReceiver) {
            this.stopAndFocus(newFocusReceiver, e);
        }
    }

    private stopAndFocus (el: any, e: any): void {
        e.stopImmediatePropagation();
        e.preventDefault();
        el.focus();
    }

    private setTabListener (el: any): void {
        el.addEventListener('keydown', this.tabListener);
    }
}
